import { render, staticRenderFns } from "./VatItem.vue?vue&type=template&id=2b56bb92&"
import script from "./VatItem.vue?vue&type=script&lang=js&"
export * from "./VatItem.vue?vue&type=script&lang=js&"
import style0 from "./VatItem.vue?vue&type=style&index=0&id=2b56bb92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports